import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { AppLoader } from './States';

// Journey: onboarding (questions + 5 challenges + report) → plan selection → app
export const ProtectedRoute = ({ children }) => {
  const { user, ready } = useAuth();
  const loc = useLocation();
  if (!ready) return <AppLoader />;
  if (!user) return <Navigate to="/auth/login" state={{ from: loc }} replace />;
  if (!user.onboarded) return <Navigate to="/onboarding" replace />;
  if (!user.planChosen && !loc.pathname.startsWith('/profile')) return <Navigate to="/choose-plan" replace />;
  return children;
};

// Onboarding is open to guests (homepage funnel) and to signed-in users who haven't finished it
export const OnboardingRoute = ({ children }) => {
  const { user, ready } = useAuth();
  if (!ready) return <AppLoader />;
  if (user?.onboarded) return <Navigate to={user.planChosen ? '/dashboard' : '/choose-plan'} replace />;
  return children;
};

// Plan selection is open to guests (choice is saved, then they sign up) and signed-in users
export const PlanRoute = ({ children }) => {
  const { user, ready } = useAuth();
  if (!ready) return <AppLoader />;
  if (user && !user.onboarded) return <Navigate to="/onboarding" replace />;
  return children;
};
